<template>
  <form-wrapper
    full-width
    full-height
  >
    <template v-slot:body>
      <info-page
        :class="{'opacity': validatingCertificate}"
        validate
      />

    </template>
    <template v-slot:footer>
      <b-button
        variant="bg-white"
        @click="onCancel()"
      >
        Cancel
      </b-button>
      <button-loading
        :spinning="validatingCertificate"
        variant="bg-primary"
        class="ml-16"
        @click="onValidate()"
      >Validate
      </button-loading>
    </template>
  </form-wrapper>
</template>
<script>
import InfoPage from './Info.vue'

export default {
  components: { InfoPage },
  computed: {
    validatingCertificate() {
      return this.$store.state.cdn.validatingCertificate
    },
  },
  methods: {
    onCancel() {
      this.$router.push({ name: 'certificates', params: { id: this.$route.params.id } })
    },
    onValidate() {
      this.$store.dispatch('cdn/validateCertificate', this.$route.params.certificateId)
        .then(() => this.onCancel())
        .catch(error => { this.errorToast(error.response?.data?.errors[0 || 'Something went wrong while validating certificate.']) })
    },
  },
}
</script>
<style lang="scss" scoped>
.opacity {
  inset: 0px;
  opacity: 0.5;
  backdrop-filter: blur(2px);
}
</style>
